import { ACTIONS } from "./actions";

const initialState = {
    loading: false,
    success: false,
    error: null,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ACTIONS.DELETE_VENDOR_LOADING:
            return {
                ...state,
                success: false,
                loading: true,
            };
        case ACTIONS.DELETE_VENDOR_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                error: null,
            };
        case ACTIONS.DELETE_VENDOR_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };

        default:
            return state;
    }
};

export default reducer;
